import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const DatasetIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? width ?? "12"}
    height={size ?? height ?? "12"}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.75125 10.5L4.1475 6L6.885 8.43375C7.05872 8.58809 7.29417 8.65318 7.5225 8.61C7.75296 8.56684 7.94998 8.41838 8.055 8.20875L10.125 4.0875L9.4425 3.75L7.38375 7.875L4.64625 5.44125C4.47695 5.28381 4.2445 5.21324 4.01625 5.25C3.79091 5.28739 3.59488 5.42543 3.48375 5.625L1.5 9.375V0.75H0.75V10.5C0.75 10.9142 1.08579 11.25 1.5 11.25H11.25V10.5H1.75125Z"
      fill="currentColor"
    />
  </svg>
)

export default DatasetIcon
